/// FOURJS_START_COPYRIGHT(D,2014)
/// Property of Four Js*
/// (c) Copyright Four Js 2014, 2026. All Rights Reserved.
/// * Trademark of Four Js Development Tools Europe Ltd
///   in the United States and elsewhere
///
/// This file can be modified by licensees according to the
/// product manual.
/// FOURJS_END_COPYRIGHT

"use strict";

modulum("FolderLayoutEngineBase", ["LayoutEngineBase"], function (context, cls) {
  /**
   * Base code for FolderEngine
   * @class FolderLayoutEngineBase
   * @memberOf classes
   * @extends classes.LayoutEngineBase
   */
  cls.FolderLayoutEngineBase = context.oo.Class(cls.LayoutEngineBase, function ($super) {
    return /** @lends classes.FolderLayoutEngineBase.prototype */ {
      __name: "FolderLayoutEngineBase",

      /**
       * @inheritDoc
       */
      DOMMeasure: function () {
        $super.DOMMeasure.call(this);
        if (this._widget.getTabsTitlesHostElement) {
          const info = this._getLayoutInfo(),
            container = this._widget.getTabsTitlesHostElement().getBoundingClientRect();
          info.setTitlesContainerDeltaWidth(info.getRawMeasure().getWidth() - container.width);
          info.setTitlesContainerDeltaHeight(info.getRawMeasure().getHeight() - container.height);
          // Measure page titles here, as pages themselves might not be in the dom
          for (const page of this._widget.getChildren()) {
            const pageTitle = page.getTitleWidget();
            if (!pageTitle) {
              continue;
            }
            const titleInfo = pageTitle.getLayoutInformation(),
              titleDOMMeasure = pageTitle.getElement().getBoundingClientRect();

            titleInfo.setTitleMeasureWidth(titleDOMMeasure.width);
            titleInfo.setTitleMeasureHeight(titleDOMMeasure.height);
          }
        }
      }
    };
  });
});
